module.exports = __webpack_public_path__ + "img/3.166fd629.jpg";